import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Button,
  Typography,
} from '@mui/material'
import { useState } from 'react'

type FilterSelectOption<T> = {
  value: T
  label: string
}

type FilterSelectProps<T> = {
  label: string
  options: FilterSelectOption<T>[]
  defaultValue?: T
  onSubmit: (params: { value: T; label: string }) => void
  onClose: () => void
  showClearButton?: boolean
}

export const FilterSelect = <T extends string | number>({
  label,
  options,
  defaultValue,
  onSubmit,
  onClose,
}: FilterSelectProps<T>) => {
  console.log({ defaultValue })
  const [selectedValue, setSelectedValue] = useState<T | undefined>(defaultValue)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as T
    setSelectedValue(value)
  }

  const handleSubmit = () => {
    if (selectedValue !== undefined) {
      onSubmit({
        value: selectedValue,
        label: options.find((o) => o.value === selectedValue)?.label ?? '',
      })
    }
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Stack sx={{ py: 2, px: 2 }}>
      <FormControl component="fieldset" sx={{ gap: 1, flexDirection: 'column' }}>
        <FormLabel component="legend">
          <Typography variant="subtitle2">{label}</Typography>
        </FormLabel>
        <RadioGroup
          value={selectedValue ?? ''}
          onChange={handleChange}
          sx={{ height: 300, overflowY: 'auto', flexWrap: 'nowrap', my: 1 }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={String(option.value)}
              value={option.value}
              control={<Radio size="small" sx={{ p: 0.5, mr: 0.5 }} />}
              label={<Typography variant="body2">{option.label}</Typography>}
              sx={{ margin: 0 }}
            />
          ))}
        </RadioGroup>
        <Stack direction="row" spacing={1} useFlexGap sx={{ alignSelf: 'flex-end' }}>
          <Button
            variant="contained"
            size="small"
            onClick={handleSubmit}
            disabled={selectedValue === undefined}
          >
            Apply
          </Button>
          <Button variant="outlined" size="small" onClick={handleClose}>
            Close
          </Button>
        </Stack>
      </FormControl>
    </Stack>
  )
}
